var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',{staticClass:"uk-text-center"},[_c('a',{staticClass:"uk-link-heading",attrs:{"href":"/"}},[_vm._v("acorn")])])])
}]

export { render, staticRenderFns }